// extracted by mini-css-extract-plugin
module.exports = {"declaration":"jGBpaN89sG251arfuX3M1A==","footer":"_0VV5XpVppaRcdssI6Fk2wQ=="};